import http from '@/utils/http'
import { Message } from 'element-ui'
const api = ({ url, method = 'get', data }) => {
  let args = {
    url,
    method,
  }
  if (method == 'get') {
    args.params = data
  } else {
    args.data = data
  }
  return new Promise((reslove, reject) => {
    http(args)
      .then((res) => {
        if (res && res.code == 1) {
          reslove(res)
        } else {
          res && res.message && Message.error(res.message)
          reslove(res)
        }
      })
      .catch((err) => {
        Message.error(err.message)
        reject(err)
      })
  })
}

/**
 * 获取全部菜单
 * @returns
 */
export const getMenuList = () => {
  return api({ url: '/admin/menu/lst/1' })
}

/**
 * 获取当前权限菜单
 * @returns
 */
export const getPermissionList = () => {
  return api({ url: '/admin/menu/route/lst' })
}

export default api
